import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import React from 'react'

export function InactiveDialog(props) {
  const {
    ID,
    openInactiveDialog,
    setOpenInactiveDialog,
    title,
    handleInactive,
    action,
    handleAction,
  } = props

  return (
    <CommonDialog
      fullWidth
      open={openInactiveDialog}
      onClose={() => setOpenInactiveDialog(false)}
      sections={{
        header: {
          title: action,
          infoLine: title,
        },
        body: () => (
          <div className="content-wrap full">
            <span
              style={{
                fontSize: '12px',
                lineHeight: '14px',
                fontWeight: 500,
              }}
            >
              {`Are you sure you want to ${handleAction} this Creditor?`}
            </span>
          </div>
        ),
        footer: {
          actions: [
            {
              displayText: 'Cancel',
              props: {
                onClick: () => setOpenInactiveDialog(false),
                variant: 'contained',
                color: 'primary',
              },
            },
            {
              displayText: 'Confirm',
              props: {
                onClick: () => {
                  handleInactive(ID)
                },

                variant: 'contained',
                color: 'primary',
              },
            },
          ],
        },
      }}
    />
  )
}
